import { render, staticRenderFns } from "./marathon_common.vue?vue&type=template&id=482598da"
import script from "./marathon_common.vue?vue&type=script&lang=js"
export * from "./marathon_common.vue?vue&type=script&lang=js"
import style0 from "./marathon_common.vue?vue&type=style&index=0&id=482598da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports